import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import BarChartCommonComponent from '../../../library/SimpleControls/BarChartCommonComponent';
import useDashboard from './useDashboard';

const ExperienceLevelDistribution = () => {
    const { state } = useContext(SmartContext);
    const { getExperienceLevelDistribution } = useDashboard();

    useEffect(() => {
        getExperienceLevelDistribution();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.experienceLevelDistribution))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state?.data?.dashboardData?.experienceLevelDistribution} />
        </>
    );
};

export default ExperienceLevelDistribution;
